import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const mapVariantToClassName = (variant) => {
    if (variant === "inline") {
        return `fade loader-container in`;
    }

    if (variant === "list") {
        return  `loader-block loader-flex` ;
    }

    if (variant === "row") {
        return  `loader-block loader-row loader-flex` ;
    }

    return "text-center";
};

const Loader = (props) => {
    const { variant, label } = props;
    const loaderClassName = mapVariantToClassName(variant);

    if (variant === "inline") {
        return (
            <div className={classNames(loaderClassName)}>
                <span className={"loader"}/>
                <span className={"loader-label"}>{label}</span>
            </div>
        );
    }

    return (
        <div className={classNames(loaderClassName)} >
            <span className={`fade in`}>
                <span className={"loader"}/>
            </span>
        </div>
    );
};

Loader.propTypes ={
    /** The variant of the loader */
    variant: PropTypes.oneOf(["inline", "list", "row"]),
    /** String text that will be displayed next to the loader when the variant prop is set to "inline" */
    label: PropTypes.string
};

export default Loader;